import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';

import ogImg from '../../assets/img/og.jpg';
import Explore from '../../components/shared/explore.js';
import Footer from '../../components/shared/Footer';
import NavBar from '../../components/shared/NavBar';

import SearchResults from '../../components/search/SearchResults';

class SearchPage extends Component {
  constructor(props) {
    super(props);
    this.onTransitionEnd.bind(this);
  }

  state = { transitionEnded: false };

  onTransitionEnd = () => {
    this.setState({ transitionEnded: true });
  };

  render() {
    const heroClasses = classnames('hero', { animate: this.state.transitionEnded });

    const q = this.props.searchPageQuery;
    if (!q) return <div className="u-hidden">Waiting</div>;
    if (q.loading) return <div className="u-hidden">Loading</div>;
    if (q.error) return <div style={{ padding: 24 }}>Error loading search chrome.</div>;

    const site = q.globalSites && q.globalSites[0];
    if (!site) {
      window.location.href = '/404';
      return null;
    }

    // Optional background for Search page
    const searchPage = q.searchPages && q.searchPages[0];
    const bgUrl = searchPage?.backgroundImage?.url || null;

    return (
      <div key="search" className={heroClasses}>
        <Helmet>
          <meta property="og:image" content={ogImg} />
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
          />
        </Helmet>

        <header id="site-header" className="container" role="banner">
          <a id="site-title" className="h1" href="/">
            <img src={site.cubsLogo.url} alt="site-header" />
          </a>

          {bgUrl ? <img src={bgUrl} alt="background" className="featured-image" /> : null}

          <NavBar NavBar={site.mainNavigation} />
        </header>

        <main className="container">
          {/* This is the missing piece that caused “empty search” */}
          <SearchResults searchPageQuery={q} location={this.props.location} />

          {/* keep explore if you want it on the search results page */}
          {q.exploreComponents && q.exploreComponents[0] ? (
            <Explore explore={q.exploreComponents[0]} />
          ) : null}
        </main>

        <Footer footer={site.mainNavigation} />
      </div>
    );
  }
}

export default SearchPage;